import {
  USER_LOGIN,
  USER_IS_LOGGED_IN,
  USER_LOGOUT,
  USER_LOGIN_GUEST,
} from '../../constants';

const login = (action, newState) => {
  newState.isAuth = action.payload.email || false;

  return newState;
};

const logout = () => {
  window.location.reload();
};

const lookUp = {
  [USER_LOGIN]: login,
  [USER_IS_LOGGED_IN]: login,
  [USER_LOGOUT]: logout,
  [USER_LOGIN_GUEST]: login,
};

const initState = { isAuth: null, };

const UserReducer = (state = initState, action) => {
  const { cmd } = action;

  if (lookUp[cmd]) return lookUp[cmd](action, { ...state });

  return state;
};
export default UserReducer;
